module.exports = __webpack_public_path__ + "img/status-failed.17970316.svg";